import React from 'react';
import DatePicker from 'react-datepicker';
import DatePickerSC from './datepicker.styled';
import 'react-datepicker/dist/react-datepicker.css';
import sk from 'date-fns/locale/sk';

const Datepicker = ({ name, value, onChange, hasError, placeholder }) => {
  return (
    <DatePickerSC className={hasError ? 'error' : ''}>
      <DatePicker
        name={name}
        placeholderText={placeholder}
        selected={value}
        dateFormat="dd.MM.yyyy"
        onChange={onChange}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        locale={sk}
        dropdownMode="select"
      />
    </DatePickerSC>
  );
};

export default Datepicker;
